module.exports = __webpack_public_path__ + "62bcf7e3fe4c8d84f93bef4983c1629f.svg";